import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { Keys } from '@/models/login';
import { LocalStorageUtils } from '@/utils';

export const useAuthStore = defineStore('auth', () => {
  const userLoggedIn = ref(false);
  const userData = ref<Keys | null>(null);

  const checkAuth = async () => {
    userData.value = LocalStorageUtils.getUserKeys();
    userLoggedIn.value = userData.value !== null;
  };

  return {
    userLoggedIn,
    userData,
    checkAuth
  };
});
